import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";
import stage2 from "./stage2.js" with { type: "text" };

export const remoteLoader: Example = {
  id: "remote-loader",
  title: "Two-stage loader",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Fetches a “config” whose body is code, then evals it: stage 2 appears as layer 1",
  explainer:
    "The page script only fetches `config.js` (a mock route serves it) and passes the response text to `eval`. The `codegen` row reveals the fetched code as **layer 1**, and its token read and POST are attributed to layer 1, so code that never appeared in the page is visible.",
  code,
  context: {
    mockRoutes: [
      {
        url: "https://cdn.example/widget/config.js",
        headers: { "content-type": "text/javascript" },
        body: stage2,
      },
    ],
  },
  expect: golden as Example["expect"],
};
